module.exports = __webpack_public_path__ + "img/pzjk.918dd0cb.png";